import { contentAi } from '@mi-front/api-clients';

export function useContentAiPrompts(content: contentAi.ContentDto) {
  const stationId = content.source.data.fragment?.station?.id as string;
  const query = contentAi.useStationConfigGet(stationId);

  return query.data?.prompts ?? [];
}
